var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from "react-router-dom";
import { GovBar } from "@uigovpe/components";
import { Header, SecondaryFooter, Footer } from "../../components";
// Dentro do portal xvia o próprio portal já exibe a faixa do Governo de PE,
// então escondemos a GovBar para não empilhar barras redundantes no topo.
// Fora do portal (app isolado), ela continua aparecendo normalmente.
var isInsidePortal = typeof window !== "undefined" && Boolean(window.__APP_BASE__);
export var PublicLayout = function () { return (_jsxs("div", __assign({ className: "flex flex-col min-h-screen" }, { children: [!isInsidePortal && _jsx(GovBar, {}), _jsx(Header, {}), _jsx("main", __assign({ className: "flex-1 flex flex-col" }, { children: _jsx(Outlet, {}) })), _jsx(SecondaryFooter, {}), _jsx(Footer, {})] }))); };
